<template>
  <div class="main-info">
    <div class="main-info-header">
      <div class="main-info-header-left">
        <div class="header-item">
          <div class="header-item-t">
            课程名称：
          </div>
          <div class="header-item-c">
            {{ info.name }}
          </div>
        </div>
        <div class="header-item">
          <div class="header-item-t">
            课件数量：
          </div>
          <div class="header-item-c">
            {{ info.courseWaresAmount }}
          </div>
        </div>
      </div>
      <div class="main-info-header-right">
        <div class="header-item">
          <div class="header-item-t">
            课程标签：
          </div>
          <div class="header-item-c">
            <div class="tag-wrapper">
              <tag-list-show-new
                :tag-list="info.showTags"
                :limit="3"
              />
            </div>
          </div>
        </div>
        <div class="header-item">
          <div class="header-item-t">
            课程说明：
          </div>
          <div class="header-item-c">
            {{ info.description }}
          </div>
        </div>
      </div>
    </div>
    <div class="main-info-content">
      <div class="content-item">
        <div class="content-item-t">
          学习人数
        </div>
        <div class="content-item-c">
          {{ statistical.learnAmount }}
        </div>
      </div>
      <div class="content-item">
        <div class="content-item-t">
          参与率
        </div>
        <div class="content-item-c">
          {{ statistical.participationRate }}
        </div>
      </div>
      <div class="content-item">
        <div class="content-item-t">
          平均学习时长/人
        </div>
        <div class="content-item-c">
          {{ statistical.learnDurationAvg }}
        </div>
      </div>
      <div class="content-item">
        <div class="content-item-t">
          已发布任务数
        </div>
        <div class="content-item-c">
          {{ statistical.missionReleaseAmount }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TagListShowNew from '@/components/tag-list-show-new/index.vue'
export default {
  components: { TagListShowNew },
  props: {
    info: {
      type: Object,
      default () {
        return {
          showTags: []
        }
      }
    },
    statistical: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .main-info {
    border: 1px solid #e8e8e8;
    border-radius: 4px;

    .main-info-header {
      display: flex;
      width: 100%;
      box-sizing: border-box;
      padding: 15px 20px;
      border-bottom: 1px solid #e8e8e8;
      background-color: #fafafa;

      .main-info-header-left {
        flex-basis: 35%;
      }

      .main-info-header-right {
        flex-basis: 50%;
      }

      .header-item {
        display: flex;
        // margin-top: 10px;

        .header-item-t {
          font-size: 13px;
          color: #595959;
          line-height: 22px;
          flex-shrink: 0;
        }

        .header-item-c {
          font-size: 13px;
          color: #262626;
          line-height: 22px;
          word-wrap: break-word;
          word-break: break-all;
          overflow: hidden;
        }
      }
    }

    .main-info-content {
      height: 80px;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;

      .content-item {
        flex: 1;
        text-align: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border-right: 1px solid #e8e8e8;

        .content-item-t {
          font-size: 12px;
          color: #8c8c8c;
          display: block;
        }

        .content-item-c {
          font-size: 13px;
          color: #262626;
          display: block;
          height: 14px;
          margin-top: 8px;
        }
      }
    }

    .tag-wrapper {
      .tag-item-wrapper {
        display: inline-flex;
        align-items: center;

        &:hover {
          .more-tag {
            background-color: #e6efff;
            border: 1px solid #d5e3ff;

            .el-icon-more {
              color: #4e78f0;
            }
          }
        }

        .tag-item {
          // width: 64px;
          height: 22px;
          padding: 0 8px;
          margin-right: 8px;
          line-height: 22px;
          background-color: #ebeff4;
          border-radius: 2px;
          color: #6b7b88;
          font-size: 12px;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          &:last-child {
            margin-right: 0;
          }
        }

        .more-tag {
          flex: none;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 25px;
          height: 22px;
          text-align: center;
          border-radius: 2px;
          border: 1px solid transparent;
          transition: all 0.3s;

          .el-icon-more {
            font-size: 12px;
            color: #767676;
          }
        }
      }
    }
  }
</style>
<style lang="scss">
.tag-popper {
  min-width: unset;
  padding: 10px 0 0 10px;

  .tag-item-wrapper {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 145px;
    max-height: 300px;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 5px;
      background-color: #fff;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background-color: rgba(193, 193, 193, 0.8);
    }

    .tag-item {
      height: 22px;
      padding: 0 8px;
      margin-right: 10px;
      margin-bottom: 10px;
      line-height: 22px;
      background-color: #ebeff4;
      color: #6b7b88;
      border-radius: 2px;
      font-size: 12px;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>
